import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CRUDPage from '../../components/admin/CRUDPage';
import { Box } from 'lucide-react';

export default function MaterialsPage() {
  const fields = [
    { 
      key: 'name', 
      label: 'Material Name', 
      type: 'text', 
      required: true,
      placeholder: 'Enter material name (e.g., PVC, Metal, Wood)'
    },
    { 
      key: 'description', 
      label: 'Description', 
      type: 'textarea', 
      required: false,
      placeholder: 'Enter material description (optional)'
    },
  ];

  return (
    <AdminLayout>
      <div className="p-8">
        <CRUDPage
          title="Materials"
          apiEndpoint="materials"
          dataKey="materials"
          fields={fields}
          icon={Box}
        />
      </div>
    </AdminLayout>
  );
}
